import { useTranslation } from 'react-i18next'
import { AvatarGroup, Avatar } from '@structural-climbing/ui'
import type { NewsAttendee } from '@structural-climbing/ui'

// Who else is going. Seeing that eleven climbers already signed up is the
// strongest reason to sign up too, so the count leads and the faces back it up.
// The count covers everyone, while only members with a public profile show a
// face — which is why the number comes from `count`, never from the avatars.
export function AttendeeAvatars({
  attendees,
  count,
}: {
  attendees: NewsAttendee[] | undefined
  count: number
}) {
  const { t } = useTranslation()
  if (count <= 0) return null

  // The worker already caps the preview, so the group never overflows and needs
  // no "+N" chip: the count text next to it is the complete number.
  const faces = attendees ?? []

  return (
    <div className="flex items-center gap-2">
      {faces.length > 0 && (
        <AvatarGroup size="sm">
          {faces.map((a) => (
            <Avatar
              key={a.user_id}
              src={a.avatar_url ?? undefined}
              name={a.name}
              size="sm"
              className="h-6 w-6 text-[10px]"
            />
          ))}
        </AvatarGroup>
      )}
      <span className="text-xs text-foreground/60">{t('events.attending', { count })}</span>
    </div>
  )
}
